import React from 'react'
import { capitalizeName, isSet } from '../../../../utils/commonUtils'
import FormInputs from '../../../../components/UI/FormInputs'
import Buttons from '../../../../components/UI/Buttons'
import PERMISSIONS from '../../../../utils/AclPermissions'
import { acl_check } from '../../../../utils/aclUtils'
import withReduxState from '../../../../hoc/wReduxState'

const SearchOverAllStatus = (props) => {
    const {data,visitDetails,overAllStatus,searchTerm,SearchHandler,ishow}=props
    const canPrintClearanceReport = acl_check(
      props?.profile?.permissions,
      PERMISSIONS.VISITS.DOWNLOAD_CLEARANCE_REPORT
    );
    const canPrintConsents = acl_check(
      props?.profile?.permissions,
      PERMISSIONS.VISITS.PRINT_CONSENTS
    );
    const canShowPrintButton = canPrintClearanceReport || canPrintConsents;
  return (
      <div class="form-group mb-0 d-flex justify-content-between align-items-center">

          {data.length > 0 ?
              <>
                  <div class="d-flex align-items-center">
                      <p class="mb-0 mx-1 badgelabel">Status</p>
                      <div class={`badge ${overAllStatus.toLowerCase() == 'passed' ? 'sh_badgeSuccess' : overAllStatus.toLowerCase() == 'not started' ? 'sh_badgePending' : overAllStatus.toLowerCase() == 'failed' ? "sh_badgeDanger" : 'sh_badgeWarning'} `}>
                          <span class="pr-1">
                              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <ellipse cx="4" cy="4" rx="4" ry="4" fill={`${overAllStatus.toLowerCase() == 'passed' ? '#0F8647' : overAllStatus.toLowerCase() == 'not started' ? '#1D2433CC' : overAllStatus.toLowerCase() == 'failed' ? "#E02D3C" : '#CA8B14'}`}></ellipse>
                              </svg>

                          </span>

                          {(isSet(visitDetails?.visit_date, '') !== '') ? capitalizeName(overAllStatus.toLowerCase()) : ''}
                      </div>
                  </div>
              </>
              :
              <div></div>
          }
         {ishow===true && <div class="d-flex">
              <FormInputs type={'TextInput'} className={'form-control  form-control-solid '} placeholder={'Search'} value={searchTerm} changeHandler={(val)=>SearchHandler(val)} />
             <Buttons
              title={"Add Physical / Drug Screen"}
              disableButtonTitle={"This Visit is Already Billed / No Permission"}
              className="btn btn-primary ml-2"
              acl={visitDetails.billing_status == 'Billed' ? PERMISSIONS.NO_PERMISSION : PERMISSIONS.VISITS.EDIT}
              clickHandler={props.addToogleHandler}
              label={'Add'}
          />
               {canShowPrintButton && <button type="button" className="btn btn-primary ml-2 dropdown dropdown-toggle position-static noArrow" data-bs-toggle="dropdown" title="Print">
                        <span >
                          <i className="fas fa-print text-md " /> Print Report
                        </span>

                        <div className="dropdown-menu dropdown-menu-left shadow" aria-labelledby="userDropdown">
                          {canPrintClearanceReport && <button type="button" className="dropdown-item" onClick={() => props.printClearanceReport()}>
                            Clearance Report
                          </button>}
                          {canPrintConsents && <button type="button" className="dropdown-item" onClick={() => props.printConsentHandler('consent form')}>
                            Print Consents
                          </button>}

                        </div>
                      </button>}
          </div>}
         
       
      </div>
  )
}

export default withReduxState(SearchOverAllStatus)